/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Stat_StreakInputs */

const bn_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্ট্রিক`)
};

const de_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strähne`)
};

const el_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ράβδωση`)
};

const en_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streak`)
};

const es_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Racha`)
};

const fr_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série`)
};

const hi_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`धारी`)
};

const hu_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Csík`)
};

const id_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Garis`)
};

const it_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strisciante`)
};

const ja_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストリーク`)
};

const ko_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`줄`)
};

const nl_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Streep`)
};

const pl_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasemko`)
};

const pt_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Onda`)
};

const ru_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полоса`)
};

const sv_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strimma`)
};

const tr_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rüzgâr gibi geçmek`)
};

const uk_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смуга`)
};

const vi_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vệt`)
};

const zh_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`条纹`)
};

const zh_hant_game_stat_streak = /** @type {(inputs: Game_Stat_StreakInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`條紋`)
};

/**
* | output |
* | --- |
* | "Streak" |
*
* @param {Game_Stat_StreakInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_stat_streak = /** @type {((inputs?: Game_Stat_StreakInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Stat_StreakInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_stat_streak(inputs)
	if (locale === "de") return de_game_stat_streak(inputs)
	if (locale === "el") return el_game_stat_streak(inputs)
	if (locale === "en") return en_game_stat_streak(inputs)
	if (locale === "es") return es_game_stat_streak(inputs)
	if (locale === "fr") return fr_game_stat_streak(inputs)
	if (locale === "hi") return hi_game_stat_streak(inputs)
	if (locale === "hu") return hu_game_stat_streak(inputs)
	if (locale === "id") return id_game_stat_streak(inputs)
	if (locale === "it") return it_game_stat_streak(inputs)
	if (locale === "ja") return ja_game_stat_streak(inputs)
	if (locale === "ko") return ko_game_stat_streak(inputs)
	if (locale === "nl") return nl_game_stat_streak(inputs)
	if (locale === "pl") return pl_game_stat_streak(inputs)
	if (locale === "pt") return pt_game_stat_streak(inputs)
	if (locale === "ru") return ru_game_stat_streak(inputs)
	if (locale === "sv") return sv_game_stat_streak(inputs)
	if (locale === "tr") return tr_game_stat_streak(inputs)
	if (locale === "uk") return uk_game_stat_streak(inputs)
	if (locale === "vi") return vi_game_stat_streak(inputs)
	if (locale === "zh") return zh_game_stat_streak(inputs)
	return zh_hant_game_stat_streak(inputs)
});